import React, {useEffect, useState} from 'react';
import {getImgUrl} from "/react4xp/parts/service-link-img/actions";
import {Skeleton} from 'antd';

const QrLink = (props: any) => {
    const {title, code, link} = props.link;

    const [img, setImg] = useState();

    useEffect(() => {
        if (code) {
            getImgUrl(code).then(
                value => {
                    if (value.data) {
                        setImg(value.data);
                    }
                }
            );
        }
    }, []);

    const routeTo = () => {
        if (link) {
            window.location.href = link;
        }
    };

    const isLink = (): string => {
        return link ? 'is-link' : '';
    };

    return (
        <div className={`qr-link text-center ${isLink()}`} onClick={routeTo}>
            <div className="title">{title}</div>
            <div className="image">
                {img ? (
                    <img src={img} alt={title} />
                    ) : (
                    <Skeleton.Image active={true} />
                )}
            </div>
        </div>
    )
};

export default QrLink;
